// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const ContentIcon = () => <Icon inverted={true} name="content" />;
